// TEMP DEBUG - remove after diagnosing the create-password regression.
const TEMP_DEBUG_LOG_KEY = '__TEMP_DEBUG_LOG__';

type DebugEntry = { label: string; data: Record<string, unknown>; time: string };

const MAX_ENTRIES = 30;

export const pushDebugLog = (label: string, data: Record<string, unknown>): void => {
  try {
    const existing: DebugEntry[] = JSON.parse(sessionStorage.getItem(TEMP_DEBUG_LOG_KEY) || '[]');
    existing.push({ label, data, time: new Date().toISOString() });
    const trimmed = existing.slice(-MAX_ENTRIES);
    sessionStorage.setItem(TEMP_DEBUG_LOG_KEY, JSON.stringify(trimmed));
  } catch {
    // Debug-only: never let logging itself break the real flow.
  }
};

export const getDebugLog = (): DebugEntry[] => {
  try {
    return JSON.parse(sessionStorage.getItem(TEMP_DEBUG_LOG_KEY) || '[]');
  } catch {
    return [];
  }
};
